/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlayerNoteCommand } from '../../models/create-player-note-command';
import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';

export interface ApiPlayerNotesPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params {
      body?: CreatePlayerNoteCommand
}

export function apiPlayerNotesPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse.PATH, 'post');
  if (params) {
    rb.body(params.body, 'text/plain');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse.PATH = '/api/player-notes';
